import BookmarkIcon from "@heroicons/react/24/outline/BookmarkIcon";
import SparklesIcon from "@heroicons/react/24/solid/SparklesIcon";
import BookmarkFilledIcon from "@mui/icons-material/Bookmark";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../../../assets/colors";

export const GridStyled = styling(Grid)((props) => ({
  //
}));

export const SectionTitle = styling(Typography)((props) => ({
  fontWeight: "700",
  fontSize: "20px",
  lineHeight: "24px",
  marginBottom: "15px",
}));

export const SimilarJobContainer = styling(Grid)((props) => ({
  minWidth: "75%",
  padding: "10px 10px 14px",
  marginBottom: "5px",
  cursor: "pointer",
  minHeight: "120px",

  border: `0.5px solid ${Color.secondaryGrey}`,
  borderRadius: "8px",
  transition: "box-shadow 0.2s ease-in-out",

  [props.theme.breakpoints.down("tablet")]: {
    minWidth: "260px",
  },

  "&:hover": {
    boxShadow: "0px 5px 0px 0px rgba(0,0,0,1)",
    border: `0.5px solid ${Color.black}`,
  },
}));

export const BookmarkIconStyled = styling(BookmarkIcon)((props) => ({
  width: "26px",
  height: "26px",
  color: Color.darkPurple,
  strokeWidth: 2.2,
}));

export const FilledBookmarkIconStyled = styling(BookmarkFilledIcon)(
  (props) => ({
    width: "22px",
    height: "22px",
    color: Color.darkPurple,
  })
);

export const SparklesIconStyled = styling(SparklesIcon)((props) => ({
  width: "10px",
  height: "10px",
}));

export const SimilarJobTitle = styling(Typography)((props) => ({
  fontWeight: "700",
  fontSize: "14px",
  lineHeight: "22px",
  color: "#000000",
}));

export const HotJobTag = styling(Grid)((props) => ({
  padding: "0px 6px",
  width: "51px",
  height: "20px",
  background: Color.lightHiredlyPurple,
  border: `1px solid ${Color.darkPurple}`,
  borderRadius: "4px",
  color: Color.darkPurple,
  fontSize: "10px",
  fontWeight: "400",
  textTransform: "uppercase",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "5px",
  letterSpacing: "1.5px",
  lineHeight: "20px",
}));

export const JobTypeTag = styling(Grid)((props) => ({
  padding: "0px 6px",
  minWidth: "65px",
  minHeight: "20px",
  background: Color.lightBlue,
  borderRadius: "4px",
  color: Color.blue,
  fontSize: "10px",
  fontWeight: "700",
  textTransform: "capitalize",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "5px",
  lineHeight: "20px",
  marginBottom: "20px",
}));

export const OutlinedButton = styling(Button)((props) => ({
  gap: "10px",
  textTransform: "capitalize",
  color: Color.black,
  fontSize: "16px",
  lineHeight: "19px",
  fontWeight: "400",
  padding: "15px 30px",
  borderRadius: "8px",
  minWidth: "200px",
  minHeight: "50px",
  backgroundColor: Color.white,
  border: `1px solid ${Color.black}`,

  "&:hover": {
    backgroundColor: Color.white,
    boxShadow: "0px 4px 0px 0px rgba(0,0,0,1)",
    border: `1px solid ${Color.black}`,
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const ImageStyled = styling("img")((props) => ({
  width: "30px",
  height: "30px",
  objectFit: "contain",
  borderRadius: "6px",
  boxShadow: "0px 1px 4px rgba(0,0,0,0.25)",
}));

export const SimilarJobCompanyName = styling(Typography)((props) => ({
  fontWeight: "400",
  fontSize: "10px",
  lineHeight: "20px",
  letterSpacing: "1.5px",
  color: "#000000",
  textTransform: "uppercase",
}));

export const IconButtonStyled = styling(IconButton)((props) => ({
  width: "35px",
  height: "35px",
}));

export const LinkStyled = styling(Link)({
  textDecoration: "none",
  textTransform: "capitalize",
  display: "flex",
});
